export const API_URL = import.meta.env.COMMON_API_URL;
export const SSR_API_URL = import.meta.env.COMMON_SSR_API_URL;
export const API_HOST = import.meta.env.COMMON_API_HOST;
export const API_PORT = import.meta.env.COMMON_API_PORT;
export const GOOGLE_CLIENT_ID = import.meta.env.COMMON_GOOGLE_CLIENT_ID;
export const GOOGLE_MAPS_KEY = import.meta.env.COMMON_GOOGLE_MAPS_API_KEY;
export const FACEBOOK_APP_ID = import.meta.env.COMMON_FACEBOOK_APP_ID;
export const AMPLITUDE_API_KEY = import.meta.env.COMMON_AMPLITUDE_API_KEY;
export const CALCULATOR_API_URL = import.meta.env.COMMON_CALCULATOR_API_URL;
export const SENTRY_DSN = import.meta.env.COMMON_SENTRY_DSN;
export const ROOT_ACCESS_DOMAIN = import.meta.env.COMMON_ROOT_ACCESS_DOMAIN;